import AuthProtected from '@/components/app/utils/auth-protected/AuthProtected';
import SubscriptionPlan from '@/models/SubscriptionPlan';
import { connectDB } from '@/utils/db/mongoose-conn';
import { useRouter } from 'next/router';
import useSwr from 'swr';
import MainHeader from '../components//app/layouts//main-header';
import CheckoutSection from '../components/app/checkout/checkout-section/CheckoutSection';

export default function CheckoutPage(props) {
   const { subscriptions } = props;
   const router = useRouter();

   const currentUser = useSwr('/api/user/current');

   if (currentUser.data.isPremium) {
      router.push('/account/subscription');
   }

   if (!currentUser.data.isPremium) {
      return (
         <>
            <CheckoutSection subscriptions={subscriptions} plans={props.plans} />
         </>
      );
   }
}

export async function getServerSideProps(context) {
   await connectDB();

   return {
      props: {
         plans: await getSubscriptionPlans(),
      },
   };
}

async function getSubscriptionPlans() {
   const plans = await SubscriptionPlan.find({
      showInPricing: true,
   }).then((plans) => JSON.parse(JSON.stringify(plans)));
   return plans;
}

CheckoutPage.getLayout = function getLayout(page) {
   return (
      <>
         <AuthProtected>
            <MainHeader />
            {page}
         </AuthProtected>
      </>
   );
};
